export default __webpack_public_path__ + "d00603b562a393efb161e2d282004e3f.svg";